import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-reactivate-account-dialog',
    templateUrl: './reactivate-account-dialog.component.html',
    styleUrls: ['./reactivate-account-dialog.component.css'],
    standalone: false
})
export class ReactivateAccountDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<ReactivateAccountDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onConfirmReactivate(): void {
    this.dialogRef.close(true);
  }
}
